import './CategoryCard.scss'

import Menu, { MenuItem } from '../../Menu/Menu'
import React, { useCallback } from 'react'

import Button from '../../../components/Button/Button'
import Checkbox from '../../Checkbox/Checkbox'
import Dropdown from '../../Dropdown/Dropdown'
import Icon from '../../../components/Icon/Icon'
import t from '../../../helpers/i18n'

const CategoryCard = ({ category_id, name, tags, logo, city, emails_count, teams_count, players_limit, onClick, onEditDynamicFields }) => {
  const hanfleEditDynamicFields = useCallback(() => onEditDynamicFields && onEditDynamicFields(category_id), [category_id, onEditDynamicFields])

  return (
    <div className='category-card-module'>
      <div className='-header'>
        <div className='-controls'>
          <div className='-menu'>
            <Checkbox />
            <div className="-divider" />
            <Dropdown button={<Icon size={16} icon='MoreIcon' />} basic>
              <Menu size="medium">
                <MenuItem title={t('Edit dynamic fields')} icon="EditIcon" onClick={hanfleEditDynamicFields} />
              </Menu>
            </Dropdown>
          </div>
          <div className='-category-name proper-noun-large-semibold'>
            {name}
          </div>
          {tags && tags.map((tag, index) => (
            <div key={index} className='-tags overline-label-small-basic'>
              <span>{tag}</span>
            </div>
          ))}
        </div>
        <div className='-logo'>
          {logo && <img src={logo} alt='' />}
        </div>
      </div>

      <div className='-description'>
        <div className='-row'>
          <div className='-label label-small-basic'>{t('City')}</div>
          <div className='-data proper-noun-small-medium'>{city}</div>
        </div>

        <div className='-row'>
          <div className='-label label-small-basic'>{t('Players limit')}</div>
          <div className='-data proper-noun-small-medium'>{players_limit ? players_limit : t('Inactive')}</div>
        </div>

        <div className='-buttons'>
          <Button size="field-sized" type="light">{emails_count}&nbsp;<span className="-card-label label-small-basic">{t('Staff emails')}</span></Button>
          <div className='-divider'></div>
          <Button size="field-sized" type="light">{teams_count}&nbsp;<span className="-card-label label-small-basic">{t('Teams')}</span></Button>
        </div>
      </div>

      <div className='-main-button'>
        <Button
          size='field-sized'
          type='light'
          color='green'
          label={t('buttons.OpenFullProfile')}
          icon='ArrowRightIcon'
          iconPosition='trailing'
          grow
          onClick={onClick}
        />
      </div>
    </div>
  )
}

export default CategoryCard
